// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import views from './views';
import plugins from './plugins';

export default {
    views,
    plugins
};



// WEBPACK FOOTER //
// ./reducers/index.js